import React, { Fragment } from 'react'
import moment from 'moment'
import { defaultStudiesDateSelect, parameterSortMapper, STUDY_DATE_TIME_FORMATS } from './constants'
// import { STUDY_DATE_TIME_FORMATS, ROLES } from './constants'
import Loadable from '../utils/Loadable'
import AuthService from '../services/AuthService'
import PriorityLabel from '../components/partials/PriorityLabel'
import { getProviderListFromLocalStorage, renderPatientNameShort } from '../utils/helpers'
import { Badge, Popover } from 'antd'
import { find, has } from 'lodash'
import { ASSIGNMENT_CASES, ASSIGNMENT_DISPLAY_TEXT } from './studies'
import { t } from '../i18n'
// import { renderPatientNameWithSuffix, renderPatientNameShort } from '../utils/helpers'
// const AssignRadiologistContainer = Loadable('containers/segment/AssignRadiologistContainer')
// const LocationAwarenessOptionsContainer = Loadable('containers/segment/LocationAwarenessOptionsContainer')
// const RadiologistAccordActionsContainer = Loadable('containers/segment/RadiologistAccordActionsContainer')
// const StudyOperationContainer = Loadable('containers/segment/StudyOperationContainer')
// const IRStudyListActionsContainer = Loadable('containers/segment/IRStudyListActionsContainer')
const SLATimerContainer = Loadable('containers/segment/SLATimerContainer')
const TATTimerContainer = Loadable('containers/segment/TATTimerContainer')
const TableActionsContainer = Loadable('containers/segment/TableActionsContainer')

// const renderCoordinationAssignForm = (text, record) => {
//   return (
//     <AssignRadiologistContainer work={record} />
//   )
// }

const renderAssignments = (value) => {
  if(value){
  const latestAssignment = value[value.length-1]
  if(latestAssignment.radiologist_name){
    return latestAssignment.radiologist_name
  } else if(latestAssignment.organization_name){
    return latestAssignment.organization_name
  } else if(latestAssignment.facility_name){
    return latestAssignment.facility_name
  } else {
    return '-'
  }

  } else {
    return '-'
  }
}

const renderWorkListActions = (text, record) => {
  const auth = new AuthService()
  return <TableActionsContainer study={record} showCloudSync showOnsiteLocations showPrintPDF showAssignmentActions showRemoveStudy auth={auth}/>
}

const renderWorkListStatus = (text, record) => {
  const auth = new AuthService()
  const { userSettings: { affiliatedGroup } } = auth.getProfile()

  let badge = <Badge text={`study ${text}`} />
  let color = '#FAAD14'
  const textLowerCase = text && text.toLowerCase()
  if(textLowerCase==='accepted' || textLowerCase==='reported' || textLowerCase==='assigned'){
    color = '#52C41A'
    badge = <span style={{textTransform: 'capitalize'}}><Badge color='green' text={`study ${textLowerCase}`} /></span>
  } else if(textLowerCase==='rejected'){
    color = '#F5222D'
    badge =  <span style={{textTransform: 'capitalize'}}><Badge color='red' text={`study ${textLowerCase}`} /></span>
  } else if(textLowerCase==='no report required'){
    badge =  <span style={{textTransform: 'capitalize'}}><Badge color='gold' text={`${textLowerCase}`} /></span>
  } else {
    badge =  <span style={{textTransform: 'capitalize'}}><Badge color='gold' text={`study ${textLowerCase}`} /></span>
  }



  const studyOwnerFacilityName = record.facility_name



  const getAssignmentDetail = (assignment, affiliatedGroup, providerOptions) => {
    let response = {
      assignmentGuid: null,
      assigneeName: '',
      assigneeGuid: '',
      assigneeType: '',
      assignmentStatusLabel: 'Unassigned',
      assignmentStatusValue: 'unassigned',
      isIndependentRadiologist: false
    }
    if (!assignment) {
      return response
    }
    response.assignmentGuid = has(assignment, 'guid') && assignment['guid']
    const { facilities, external_radiologists: independentRadiologists, internal_radiologists: radiologists, providers } = providerOptions || {}
    const assignmentProviderGuid = (has(assignment, 'provider_guid') && assignment['provider_guid']) || (has(assignment, 'organization_guid') && assignment['organization_guid'])
    const assignmentFacilityGuid = has(assignment, 'facility_guid') && assignment['facility_guid']
    const assignmentRadiologistGuid = has(assignment, 'radiologist_id') && assignment['radiologist_id']
    const assignmentStatusValue = has(assignment, 'status') && assignment['status']
    const assignmentStatusLabel = ASSIGNMENT_DISPLAY_TEXT[assignmentStatusValue.toLowerCase()]
    const currentUserIsAtProvider = assignmentProviderGuid && assignmentProviderGuid === affiliatedGroup
    const providerNameAtSource = !currentUserIsAtProvider && assignmentProviderGuid && find(providers, { guid: assignmentProviderGuid })
    if (assignmentProviderGuid) {
      if (!assignmentFacilityGuid && !assignmentRadiologistGuid) { // Only Provider
        response.assigneeName = currentUserIsAtProvider ? 'My Organization' : providerNameAtSource && providerNameAtSource.name
      } else if (!assignmentFacilityGuid && assignmentRadiologistGuid) { // Radiologist or Independent Radiologist of the Provider
        let assignedPersonFromRadiologistList = find(radiologists, { guid: assignmentRadiologistGuid })
        if (!assignedPersonFromRadiologistList) {
          response.isIndependentRadiologist = true
          assignedPersonFromRadiologistList = find(independentRadiologists, { guid: assignmentRadiologistGuid })
        }
        response.assigneeName = currentUserIsAtProvider ? (assignedPersonFromRadiologistList && assignedPersonFromRadiologistList.name) : providerNameAtSource

      } else if (assignmentFacilityGuid && !assignmentRadiologistGuid) { // Facility of the provider
        response.assigneeName = currentUserIsAtProvider ? find(facilities, { guid: assignmentFacilityGuid }).name : providerNameAtSource

      }
    } else if (!assignmentProviderGuid) {
      if (!assignmentFacilityGuid && assignmentRadiologistGuid) { // Radiologist or Independent Radiologist of the Source Organization
        let assignedPersonFromRadiologistList = find(radiologists, { guid: assignmentRadiologistGuid })
        if (!assignedPersonFromRadiologistList) {
          response.isIndependentRadiologist = true
          assignedPersonFromRadiologistList = find(independentRadiologists, { guid: assignmentRadiologistGuid })
        }
        if (assignedPersonFromRadiologistList) {
          response.assigneeName = assignedPersonFromRadiologistList.name
        }
      } else if (assignmentFacilityGuid && !assignmentRadiologistGuid) { // Facility of the Source Organization
        response.assigneeName = find(facilities, { guid: assignmentFacilityGuid }) ? find(facilities, { guid: assignmentFacilityGuid }).name : "-"
      }
    }
    response.assignmentStatusLabel = assignmentStatusLabel

    return response
  }
  const providerOptions = getProviderListFromLocalStorage()


  const { assigneeName } = getAssignmentDetail(record.assignment, affiliatedGroup, providerOptions)
  let updatedAssigneeName = assigneeName

  const reporterTooltipMessage =(
    <div>
      {<p><b>{t('common.source_facility')}</b>{studyOwnerFacilityName}</p>}
      <p><b>{t('common.rad_name')}</b>{updatedAssigneeName || 'Unassigned'}</p>
      {/* <p><b>Radiologist Role: </b>{assigneeType || '' }</p> */}
      <p style={{color: color}}><b>{t('common.status')}</b><span style={{textTransform: 'capitalize'}}>{textLowerCase}</span></p>
    </div>
  )

  return <Popover overlayClassName="popover-worklist" placement="bottomRight" content={reporterTooltipMessage} title={null}>
            <div style={{cursor: 'pointer'}}>{badge}</div>
        </Popover>
}
const renderMyUploadsActions = (text, record) => {
  const auth = new AuthService()
  return <TableActionsContainer study={record} showCloudSync showOnsiteLocations showDownloadZip showSelfStudyActions auth={auth} />
}
const renderStudyListActions = (text, record) => {
  const auth = new AuthService()
  return <TableActionsContainer study={record} showCloudSync showOnsiteLocations showDownloadZip showPrintPDF auth={auth} />
}

// const renderDICOMImageCount = (text, record) => {
//   return <div style={{ textAlign: 'center' }}>{text || '-'}</div>
// }

// const renderTimeOfUpload = (text, record) => {
//   const { created_at: createdAt, priority } = record
//   return (
//     <div>
//       <div style={{ display: 'inline' }}>{moment.utc(moment(createdAt).toDate()).local().format(STUDY_DATE_TIME_FORMATS.workList)}</div>
//       {priority && <PriorityLabel label={priority.toLowerCase()} />}
//     </div>
//   )
// }

const renderCreatedAtDate = (text, record) => {
  const { created_at: createdAt } = record
  return moment.utc(moment(createdAt).toDate()).local().format(STUDY_DATE_TIME_FORMATS.studyList)
}

export const renderSelectionDate = (val, record) => {
  if (val && record) {
    const { created_at: createdAt, updated_at: updatedAt, study_datetime: studyDateTime } = record
    if (val === defaultStudiesDateSelect && !studyDateTime) return ''
    return moment.utc(moment(val === 'created_at' ? createdAt : val === 'updated_at' ? updatedAt : studyDateTime).toDate()).local().format(STUDY_DATE_TIME_FORMATS.studyList)
  }
}

const renderModalityWithPriority = (text, record) => {
  const { modality, priority } = record
  return (
    <div>
      <div style={{ display: 'inline' }}>{modality}</div> {priority && <PriorityLabel label={priority.toLowerCase()} />}
    </div>
  )
}


const renderTATTimer = (text, record) => {
  const { assignment, created_at: createdAt, priority, updated_at: updatedAt, report } = record
  let reportGuid, reportSignedAt
  if (assignment) {
    const { report_guid: assignmentReportGuid, report_signed_at: assignmentReportSignedAt, status } = assignment
    reportGuid = assignmentReportGuid
    reportSignedAt = assignmentReportSignedAt
    if(status === ASSIGNMENT_CASES.REJECTED || status === ASSIGNMENT_CASES.NO_REPORT){
      return <div>-</div>
    }
    if(status === ASSIGNMENT_CASES.MARKED_AS_REPORTED && !report){
      return <TATTimerContainer createdAt={createdAt} updatedAt={updatedAt} disabled={true} studyPriority={priority} reportGuid={reportGuid} reportSignedAt={reportSignedAt} />
    }
  }
  return <TATTimerContainer createdAt={createdAt} studyPriority={priority} reportGuid={reportGuid} reportSignedAt={reportSignedAt} />
}

const renderSLATimer = (text, record) => {
  const { assignment, created_at: createdAt, priority } = record
  let reportGuid, reportSignedAt
  if (assignment) {
    const { report_guid: assignmentReportGuid, report_signed_at: assignmentReportSignedAt } = assignment
    reportGuid = assignmentReportGuid
    reportSignedAt = assignmentReportSignedAt
  }
  return <SLATimerContainer createdAt={createdAt} studyPriority={priority} reportGuid={reportGuid} reportSignedAt={reportSignedAt} />
}
const renderPatientId = (type, record) => {
  const { patient_id: patientId } = record
  return (
    <Fragment>
      {patientId}
    </Fragment>
  )
}
// const renderStatus = (text, record) => {
//   const { status = null } = record
//   if (status) {
//     const { label = null } = status
//     return label || ''
//   }
//   return status || ''
// }
// const renderGlobalStatus = (text, record) => {
//   const { global_status: globalStatus = null } = record
//   return globalStatus || ''
// }
// const renderAssignmentStatus = (text, record) => {
//   const { assignment_status: assignmentStatus = null } = record
//   if (assignmentStatus) {
//     const { label = null } = assignmentStatus
//     return label || ''
//   }
//   return assignmentStatus || ''
// }

export const userGroupSettings = () => {
  let radiologistSettings = {
    studyList: {
      columns: [
        ['order', { cellClickable: true, filter: false, sort: false, customMultiSort: true, customSelectTitle: parameterSortMapper}],
        ['patient_name', { cellClickable: true, filter: { presets: { isMultiple: false, textSearch: true } }, sort: false, title: t('study_table.patient_name'), render: renderPatientNameShort }],
        ['modality', { cellClickable: true, filter: { presets: { configurationKey: 'modality', isMultiple: true, textSearch: false } }, sort: false, title: t('study_table.mod'), render: renderModalityWithPriority }],
        ['body_part', { cellClickable: true, filter: { presets: { configurationKey: 'body_part', isMultiple: true, textSearch: false, showSearch: true  } }, sort: false, title: t('study_table.body_part') }],
        ['patient_id', { cellClickable: true, filter: { presets: { isMultiple: false, textSearch: true } }, sort: false, title: t('study_table.patient_id'), render: renderPatientId }],
        ['facility_name', { cellClickable: true, filter: { presets: { configurationKey: 'facility_name', isMultiple: true, textSearch: false } }, sort: false, title: t('study_table.source') }],
        ['assignments', { cellClickable: true, filter: false, sort: false, title: t('study_table.assignment'), render: (value) => renderAssignments(value)}],
        // ['assignments', { cellClickable: true, filter: { presets: { isMultiple: false, textSearch: true } }, sort: false, title: 'Assignment', render: (value) => renderAssignments(value)}],
        // ['status', { cellClickable: true, filter: false, sort: false, title: 'Status' }],
        ['status', { cellClickable: true, filter: { presets: { configurationKey: 'status', isMultiple: true, textSearch: false } }, sort: false, title: t('study_table.status') }],
        ['', { cellClickable: false, filter: false, sort: false, render: renderStudyListActions, width: 10 }]
      ],
      // columns: [
      //   ['order', { cellClickable: true, filter: false, sort: false, customMultiSort: true, customSelectTitle: parameterSortMapper }],
      //   ['patient_name', { cellClickable: true, filter: { presets: { isMultiple: false, textSearch: true } }, sort: false, title: 'Patient Name', render: renderPatientNameShort }],
      //   ['modality', { cellClickable: true, filter: { presets: { configurationKey: 'modality', isMultiple: true, textSearch: false } }, sort: false, title: 'Mod', render: renderModalityWithPriority }],
      //   ['body_part', { cellClickable: true, filter: { presets: { configurationKey: 'body_part', isMultiple: true, textSearch: false, showSearch: true  } }, sort: false, title: 'Body Part' }],
      //   ['patient_id', { cellClickable: true, filter: { presets: { isMultiple: false, textSearch: true } }, sort: false, title: 'Patient ID', render: renderPatientId }],
      //   ['facility_name', { cellClickable: true, filter: { presets: { configurationKey: 'facility_name', isMultiple: true, textSearch: false } }, sort: false, title: 'Source' }],
      //   ['assignments', { cellClickable: true, filter: false, sort: false, title: 'Assignment', render: (value) => renderAssignments(value)}],
      //   // ['assignments', { cellClickable: true, filter: { presets: { isMultiple: false, textSearch: true } }, sort: false, title: 'Assignment', render: (value) => renderAssignments(value)}],
      //   // ['status', { cellClickable: true, filter: false, sort: false, title: 'Status' }],
      //   ['status', { cellClickable: true, filter: { presets: { configurationKey: 'status', isMultiple: true, textSearch: false } }, sort: false, title: 'Status' }],
      //   ['', { cellClickable: false, filter: false, sort: false, render: renderStudyListActions, width: 10 }]
      // ],
      selectors: {
        priority: true
      }
    },
    workList: {
      columns: [
        ['order', { cellClickable: true, filter: false, sort: false, customMultiSort: true, title: t('work_list.table.tat'), width: 300, render: renderTATTimer }],
        ['patient_name', { cellClickable: true, filter: { presets: { isMultiple: true, textSearch: false } }, sort: false, title: t('work_list.table.patient_name'), render: renderPatientNameShort }],
        ['modality', { cellClickable: true, filter: { presets: { configurationKey: 'modality', isMultiple: true, textSearch: false } }, sort: false, title: t('work_list.table.mod') }],
        ['body_part', { cellClickable: true, filter: { presets: { configurationKey: 'body_part', isMultiple: true, textSearch: false, showSearch: true  } }, sort: false, title: t('work_list.table.body_part') }],
        ['status', { cellClickable: true, filter: false, sort: false, title: t('work_list.table.status'), render: renderWorkListStatus }],
        // ['', { cellClickable: false, filter: false, sort: false, title: '', width: 100, render: renderLocationOptions }],
        ['', { cellClickable: false, filter: false, sort: false, width: 100, render: renderWorkListActions}]
      ],
      tabs: 'All',
      selectors: {
        assignTo: false,
        modality: false,
        priority: false,
        filter: true
      }
    },
    irStudyList: {
      columns: [
        // ['order', { cellClickable: true, filter: false, sort: false, customMultiSort: true, customSelectTitle: parameterSortMapper}],
        ['order', { cellClickable: true, filter: false, sort: false, customMultiSort: true, title: 'Time of Upload', render: renderCreatedAtDate }],
        ['patient_name', { cellClickable: true, filter: { presets: { isMultiple: false, textSearch: true } }, sort: false, title: 'Patient Name', render: renderPatientNameShort }],
        ['modality', { cellClickable: true, filter: { presets: { configurationKey: 'modality', isMultiple: true, textSearch: false } }, sort: false, title: 'Mod', render: renderModalityWithPriority }],
        ['body_part', { cellClickable: true, filter: { presets: { configurationKey: 'body_part', isMultiple: true, textSearch: false, showSearch: true } }, sort: false, title: 'Body Part' }],
        ['facility_name', { cellClickable: true, filter: { presets: { configurationKey: 'facility_name', isMultiple: true, textSearch: false } }, sort: false, title: 'Source' }],
        ['assignments', { cellClickable: true, filter: false, sort: false, title: 'Assignment', render: (value) => renderAssignments(value)}],
        ['status', { cellClickable: true, filter: false, sort: false, title: 'Status' }],
        // ['', { cellClickable: false, filter: false, sort: false, title: '', width: 100, render: renderLocationOptions }],
        ['', { cellClickable: false, filter: false, sort: false, title: '', width: 100, render: renderMyUploadsActions }]
      ],
      tabs: 'All',
      selectors: {
        assignTo: false,
        modality: false,
        priority: true
      }
    }
  }
  return radiologistSettings
}

// const radiographerSettings = {
//   allowedSidebarItems: ['works'],
//   allowedToAddStudy: true,
//   study: {
//     allowed: true,
//     actions: {
//       assignServiceProvider: true,
//       editDetail: true,
//       editReport: false,
//       viewDetail: false,
//       viewReport: true
//     }
//   },
//   studyList: {
//     allowed: false,
//     columns: null,
//     selectors: {
//       priority: false
//     }
//   },
//   workList: {
//     columns: [
//       ['created_at', { cellClickable: true, filter: false, sort: true, title: 'Time of Upload', render: renderTimeOfUpload }],
//       ['patient_id', { cellClickable: true, filter: { presets: { isMultiple: false, textSearch: true } }, sort: false, title: 'Patient ID', render: renderPatientId }],
//       ['patient_name', { cellClickable: true, filter: { presets: { isMultiple: false, textSearch: true } }, sort: false, title: 'Patient Name', render: renderPatientNameWithSuffix, width: '200px' }],
//       ['accession_number', { cellClickable: true, filter: { presets: { isMultiple: false, textSearch: true } }, sort: false, title: 'Accession ID' }],
//       ['body_part', { cellClickable: true, filter: { presets: { configurationKey: 'body_part', isMultiple: true, textSearch: false } }, sort: false, title: 'Body Part' }],
//       ['global_status', { cellClickable: true, filter: false, sort: false, title: 'Status' }],
//       ['number_of_dicom_images', { cellClickable: true, filter: false, sort: false, title: 'Images', render: renderDICOMImageCount }],
//       ['', { cellClickable: false, filter: false, sort: false, render: renderStudyOptions, width: 30 }]
//       // ['action', { title: 'Reject', width: 50, render: renderRejectButton, sort: false }]
//     ],
//     tabs: 'modality',
//     selectors: {
//       assignTo: false,
//       modality: true,
//       priority: false

//     }
//   }
// }

// const coordinatorSettings = {
//   allowedSidebarItems: ['works'],
//   allowedToAddStudy: false,
//   study: {
//     allowed: false,
//     actions: {
//       assignServiceProvider: false,
//       editDetail: false,
//       editReport: false,
//       viewDetail: false,
//       viewReport: false
//     }
//   },
//   studyList: {
//     allowed: false,
//     columns: null,
//     selectors: {
//       priority: false
//     }
//   },
//   workList: {
//     columns: [
//       ['sla_countdown', { filter: false, sort: true, title: 'SLA Countdown', render: renderSLATimer }],
//       ['modality', { filter: { presets: { configurationKey: 'modality', isMultiple: true, textSearch: false } }, sort: false, title: 'Mod' }],
//       ['body_part', { filter: { presets: { configurationKey: 'body_part', isMultiple: true, textSearch: false } }, sort: false, title: 'Body Part' }],
//       ['patient_name', { filter: { presets: { isMultiple: false, textSearch: true } }, sort: false, title: 'Patient Name', render: renderPatientNameShort }],
//       ['assign_to', { filter: { presets: { configurationKey: 'radiologist', isMultiple: true, textSearch: false } }, sort: false, title: 'Assigned To', render: renderCoordinationAssignForm }],
//       ['global_status', { filter: false, sort: false, title: 'Status' }]
//     ],
//     tabs: 'All',
//     selectors: {
//       assignTo: true,
//       modality: false,
//       priority: true
//     }
//   }
// }

// const independentRadiologistSettings = {
//   allowedSidebarItems: ['my-uploads', 'works'], // 'studies'
//   allowedToAddStudy: true,
//   study: {
//     allowed: true,
//     actions: {
//       assignServiceProvider: true,
//       editDetail: false,
//       editReport: true,
//       viewDetail: true,
//       viewReport: true
//     }
//   },
//   irStudyList: {
//     columns: [
//       ['created_at', { cellClickable: true, filter: false, sort: true, title: 'Time of Upload', render: renderCreatedAtDate }],
//       ['modality', { cellClickable: true, filter: { presets: { configurationKey: 'modality', isMultiple: true, textSearch: false } }, sort: false, title: 'Mod', render: renderModalityWithPriority }],
//       ['body_part', { cellClickable: true, filter: { presets: { configurationKey: 'body_part', isMultiple: true, textSearch: false } }, sort: false, title: 'Body Part' }],
//       ['patient_name', { cellClickable: true, filter: { presets: { isMultiple: false, textSearch: true } }, sort: false, title: 'Patient Name', render: renderPatientNameShort }],
//       ['facility_name', { cellClickable: true, filter: { presets: { configurationKey: 'facility_name', isMultiple: false, textSearch: true } }, sort: false, title: 'Source' }],
//       ['global_status', { cellClickable: true, filter: false, sort: false, title: 'Status' }],
//       ['', { cellClickable: false, filter: false, sort: false, title: '', width: 100, render: renderIRStudyOptions }]
//     ],
//     tabs: 'All',
//     selectors: {
//       assignTo: false,
//       modality: false,
//       priority: true
//     }
//   },
//   studyList: {
//     allowed: false,
//     columns: null,
//     selectors: {
//       priority: false
//     }
//   },
//   workList: {
//     columns: [
//       ['sla_countdown', { cellClickable: true, filter: false, sort: true, title: 'SLA Countdown', render: renderSLATimer }],
//       ['modality', { cellClickable: true, filter: true, sort: false, title: 'Mod' }],
//       ['body_part', { cellClickable: true, filter: true, sort: false, title: 'Body Part' }],
//       ['patient_name', { cellClickable: true, filter: { presets: { isMultiple: false, textSearch: true } }, sort: false, title: 'Patient Name', render: renderPatientNameShort }],
//       ['facility_name', { cellClickable: true, filter: { presets: { configurationKey: 'facility_name', isMultiple: true, textSearch: false } }, sort: false, title: 'Source' }],
//       ['global_status', { cellClickable: true, filter: true, sort: false, title: 'Status' }],
//       ['accept_or_reject', { cellClickable: false, filter: false, sort: false, title: 'Accept', width: 100, render: renderRadiologistActionButton }]
//     ],
//     tabs: 'All',
//     selectors: {
//       assignTo: false,
//       modality: false,
//       priority: true
//     }
//   }
// }

// export const settings = {
//   'coordinator': coordinatorSettings,
//   'independent-radiologist': independentRadiologistSettings,
//   'radiographer': radiographerSettings,
//   'radiologist': radiologistSettings
// }
